import React from 'react'
import 'firebase/auth'

const useFirebaseAuthPeristed = (firebaseApp: firebase.app.App) => {
  const [user, setUser] = React.useState<firebase.User | null>(null)
  React.useEffect(() => firebaseApp.auth().onAuthStateChanged(setUser), [firebaseApp])
  return user
}

export default useFirebaseAuthPeristed